import React from "react";

const interpolate = (str = "", data = {}) => (
  <>
    {str.split(/{{(.*?)}}/gi).map((item) => (
      <React.Fragment key={item}>
        {item in data ? data[item] : item}
      </React.Fragment>
    ))}
  </>
);

export default interpolate;
